import styled from "styled-components";
import { LAYOUT } from "@/constants/styles";

export const StyledAppleButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  margin: ${LAYOUT.GUTTER / 4}px;
`;
